module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Gc-Ha-Ib-Ja.b8aa459f.png";